import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { IconButton as FluentUIIconButton } from '@fluentui/react';

import { BaseButton } from '../BaseButton';
import { IButtonImplProps } from '../BaseButton.types';

export const IconButton = (props: IButtonImplProps) => <BaseButton componentAs={FluentUIIconButton} {...props} />;
